import React from "react";
import { Grid } from "@mui/material";
import DashboardCharts from "components/layouts/DashboardChart";

const Dashboard = () => {
  return (
    <Grid container>
      <DashboardCharts />
    </Grid>
  );
};

export default Dashboard;
